import { useQuery } from "@tanstack/react-query";
import { useContext, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import BorseContext from "../../context/borse";
import UserContext from "../../context/user";
import useBorseDocumentsUploadMutation from "../../hooks/mutations/useBorseDocumentsUploadMutation";
import Question from "../question";
import SendDocumentsModal from "./send-documents-modal";

const DocumentIntegration = () => {
  const { callApi } = useContext(UserContext);
  const { labels, currentRequest, appLang } = useContext(BorseContext);
  const {
    register,
    handleSubmit,
    control,
    trigger,
    reset,
    formState: { errors, touchedFields, dirtyFields },
  } = useForm({
    mode: "onTouched",
  });
  const [sendDocumentsModal, setSendDocumentModal] = useState(false);
  const [files, setFiles] = useState();

  const question = {
    answers: [],
    id: "files",
    label: labels?.WELFARE_BORSE_LOAD_DOCS || "Carica documenti",
    maxNAnswers: -1,
    minNAnswers: 1,
    position: 1,
    questionType: "File upload",
    status: "PUBLISHED",
  };

  const {
    data: alreadyLoadedFiles,
    isError: errorGetDocumentation,
    isFetching: isGetDocumentationFetching,
  } = useQuery(
    ["additional-documents"],
    () => callApi(`/scholarship/request/${currentRequest?.id}/additionalFiles`),
    {
      select: (data) => data?.map((doc) => doc.fileId),
      onSuccess: (data) => {
        reset({ files: data });
      },
    }
  );

  const isUploadBeforeConfirmNeeded = useMemo(
    () =>
      alreadyLoadedFiles &&
      (alreadyLoadedFiles?.length !== files?.length ||
        !alreadyLoadedFiles?.every((elem) => files?.includes(elem))),
    [alreadyLoadedFiles, files]
  );

  const {
    mutateAsync: uploadDocuments,
    isError,
    isFetching: isUploadFetching,
  } = useBorseDocumentsUploadMutation();

  const onSaveDraft = async (values) => {
    console.log("Saving draft", values);
    await uploadDocuments({
      request: currentRequest,
      files: values?.files,
    });
  };

  const onSubmit = (values) => {
    setSendDocumentModal(true);
    setFiles(values.files);
  };

  return (
    <div className="borse-content__document-integration">
      <div className="app-content__text">
        <strong>
          {labels?.WELFARE_BORSE_INTEGRATE_DOCS ||
            "A completamento della tua domanda ti chiediamo di integrare la documentazione caricando i seguenti documenti:"}
        </strong>
      </div>
      <ul className="borse-content__document-list">
        {currentRequest?.additionalDocumentationFiles?.map((doc, i) => (
          <li key={i}>
            {labels?.[`WELFARE_BORSE_DOCTYPE_${doc.fileType.toUpperCase()}`] ||
              `${doc.fileType[0].toUpperCase()}${doc.fileType.slice(1).toLowerCase()}`}
          </li>
        ))}
      </ul>
      <div className="borse-content__document-note">{currentRequest?.documentationNotes}</div>
      {errorGetDocumentation && (
        <p className="form__error text-center">
          Error retrieving user's previously uploaded documentation
        </p>
      )}
      {isGetDocumentationFetching ? (
        <div className="loading-spinner" />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Question
            question={question}
            register={register}
            error={errors.files}
            touched={touchedFields.files}
            isDirty={dirtyFields.files}
            control={control}
            trigger={trigger}
            labels={labels}
            locale={appLang?.value}
          />
          <div className="form__buttons-wrapper">
            {isError && (
              <p className="form__error text-center">
                {labels?.WELFARE_BORSE_ERROR_SAVING_REQUEST || "Error saving requests"}
              </p>
            )}
            <div className="form__buttons form__buttons--center">
              <button
                className="button secondary form__submit desktop-only"
                type="button"
                onClick={handleSubmit(onSaveDraft)}
              >
                {isUploadFetching && <span className="loading-spinner" />}
                {labels?.WELFARE_FORM_BTN_SAVE_DRAFT || "Save draft"}
              </button>
              <button className="button primary form__submit" id="confirm">
                {labels?.WELFARE_FORM_BTN_SEND_DOCUMENTS || "Send documents"}
              </button>
            </div>
          </div>
        </form>
      )}
      <SendDocumentsModal
        show={!!sendDocumentsModal}
        closeModal={() => setSendDocumentModal(false)}
        key={!!sendDocumentsModal}
        files={files}
        isUploadBeforeConfirmNeeded={isUploadBeforeConfirmNeeded}
      />
    </div>
  );
};

export default DocumentIntegration;
